import { MessageDescriptor } from "@formatjs/intl/src/types";
import { defineMessages } from "react-intl";

import CountryCode from "@mapmycustomers/shared/enum/CountryCode";
import TerritoryLevel from "@mapmycustomers/shared/enum/TerritoryLevel";

export const bannerDescription: Partial<
  Record<CountryCode, Record<TerritoryLevel, MessageDescriptor>>
> = {
  [CountryCode["AUSTRALIA"]]: defineMessages({
    [TerritoryLevel.ADM1]: {
      id: "map.territory.topPanel.banner.smart.description.au-adm1",
      defaultMessage: "Click to include or exclude map areas at the State level.",
      description:
        "Description in a territory banner at the top of the page when creating/editing a AU-States territory",
    },
    [TerritoryLevel.ADM2]: {
      id: "map.territory.topPanel.banner.smart.description.au-adm2",
      defaultMessage:
        "Click to include or exclude Local Government Areas. You can also add in bulk by clicking on a State.",
      description:
        "Description in a territory banner at the top of the page when creating/editing a AU-LGA territory",
    },
    [TerritoryLevel.ADM3]: {
      id: "map.territory.topPanel.banner.smart.description.au-adm3",
      defaultMessage:
        "Click to include or exclude Postal Codes. You can also add in bulk by clicking on a State or Local Government Areas.",
      description:
        "Description in a territory banner at the top of the page when creating/editing a AU-Postal Codes territory",
    },
  }),
  [CountryCode["CANADA"]]: defineMessages({
    [TerritoryLevel.ADM1]: {
      id: "map.territory.topPanel.banner.smart.description.ca-adm1",
      defaultMessage: "Click to include or exclude map areas at the Province level.",
      description:
        "Description in a territory banner at the top of the page when creating/editing a CA-Province territory",
    },
    [TerritoryLevel.ADM2]: {
      id: "map.territory.topPanel.banner.smart.description.ca-adm2",
      defaultMessage:
        "Click to include or exclude Counties. You can also add in bulk by clicking on a Province.",
      description:
        "Description in a territory banner at the top of the page when creating/editing a CA-Counties territory",
    },
    [TerritoryLevel.ADM3]: {
      id: "map.territory.topPanel.banner.smart.description.ca-adm3",
      defaultMessage:
        "Click to include or exclude Postal Codes. You can also add in bulk by clicking on a Province or County.",
      description:
        "Description in a territory banner at the top of the page when creating/editing a CA-Postal Codes territory",
    },
  }),
  [CountryCode["UNITED KINGDOM OF GREAT BRITAIN AND NORTHERN IRELAND"]]: defineMessages({
    [TerritoryLevel.ADM1]: {
      id: "map.territory.topPanel.banner.smart.description.uk-adm1",
      defaultMessage: "Click to include or exclude map areas at the Country level.",
      description:
        "Description in a territory banner at the top of the page when creating/editing a UK-Countries territory",
    },
    [TerritoryLevel.ADM2]: {
      id: "map.territory.topPanel.banner.smart.description.uk-adm2",
      defaultMessage:
        "Click to include or exclude Census Districts. You can also add in bulk by clicking on a Country.",
      description:
        "Description in a territory banner at the top of the page when creating/editing a UK-Districts territory",
    },
    [TerritoryLevel.ADM3]: {
      id: "map.territory.topPanel.banner.smart.description.uk-adm3",
      defaultMessage:
        "Click to include or exclude Postal Codes. You can also add in bulk by clicking on a Country or Census District.",
      description:
        "Description in a territory banner at the top of the page when creating/editing a UK-Postal Codes territory",
    },
  }),
  [CountryCode["UNITED STATES OF AMERICA"]]: defineMessages({
    [TerritoryLevel.ADM1]: {
      id: "map.territory.topPanel.banner.smart.description.us-adm1",
      defaultMessage: "Click to include or exclude map areas at the State level.",
      description:
        "Description in a territory banner at the top of the page when creating/editing a US-States territory",
    },
    [TerritoryLevel.ADM2]: {
      id: "map.territory.topPanel.banner.smart.description.us-adm2",
      defaultMessage:
        "Click to include or exclude Counties. You can also add in bulk by clicking on a State.",
      description:
        "Description in a territory banner at the top of the page when creating/editing a US-Counties territory",
    },
    [TerritoryLevel.ADM3]: {
      id: "map.territory.topPanel.banner.smart.description.us-adm3",
      defaultMessage:
        "Click to include or exclude Zip Codes. You can also add in bulk by clicking on a State or County.",
      description:
        "Description in a territory banner at the top of the page when creating/editing a US-Postal Codes territory",
    },
  }),
};
